import { proxy } from "valtio";
import {
  AsoEbi,
  AsoEbiStatus,
  AsoEbiTransactionCostBearer,
  Bank,
  DisplayStatus,
  SettlementAccount,
} from "../types/aso.ebi";
import { getSettlementAccount } from "../apis/aso-ebi/get.settlement.account";
import { Wedding } from "../types/wedding";
import { AsoEbiTxnMeta, Transaction } from "../types/transaction";

export const createDefaultAsoEbi = (): AsoEbi => ({
  _id: "",
  accountID: "",
  weddingID: "",
  coverImage: "",
  description: "",
  category: "",
  displayStatus: DisplayStatus.Shown,
  availableQty: null as any,
  price: null as any,
  quantityIssued: null as any,
  currentReservations: null as any,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const createDefaultSettlementAccount = (): SettlementAccount => ({
  _id: "",
  accountID: "",
  weddingID: "",
  bankID: "",
  bankName: "",
  accountName: "",
  accountNumber: "",
  additionalInfo: "",
  subAccountID: "",
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const AsoEbiStore = proxy<{
  currentAsoEbi: AsoEbi;
  asoEbis: AsoEbi[];
  asoEbiStatus: AsoEbiStatus;
  asoEbiTransactionCostBearer: AsoEbiTransactionCostBearer;
  isAsoEbiDrawerOpen: boolean;
  isHistoryDrawerOpen: boolean;
  isSettingsModalOpen: boolean;
  asoEbiDrawerOpenCtx: "edit" | "create";
  settlementAccount: SettlementAccount;
  isStlmtDrawerOpen: boolean;
  settlementBalance: number;
  stlmtDrawerOpenCtx: "edit" | "create";
  transactions: Transaction<AsoEbiTxnMeta>[];
  settlementHistory: {
    settlementDate: string;
    settlementAmount: number;
  }[];
}>({
  currentAsoEbi: createDefaultAsoEbi(),
  asoEbis: [],
  isAsoEbiDrawerOpen: false,
  asoEbiDrawerOpenCtx: "create",
  isHistoryDrawerOpen: false,
  isSettingsModalOpen: false,
  settlementAccount: createDefaultSettlementAccount(),
  isStlmtDrawerOpen: false,
  stlmtDrawerOpenCtx: "create",
  settlementBalance: 0,
  transactions: [],
  settlementHistory: [],
  asoEbiStatus: AsoEbiStatus.AsoEbiStatusOff,
  asoEbiTransactionCostBearer:
    AsoEbiTransactionCostBearer.AsoEbiTransactionCostBearerBuyer,
});

export const onSettlementDrawer =
  (state: "open" | "close", ctx: "create" | "edit" = "create") =>
  () => {
    AsoEbiStore.stlmtDrawerOpenCtx = ctx;
    AsoEbiStore.isStlmtDrawerOpen = state === "open";
  };

export const onSettlementHistoryDrawer = (state: "open" | "close") => () => {
  AsoEbiStore.isHistoryDrawerOpen = state === "open";
};

export const onAsoEbiDrawer =
  (state: "open" | "close", ctx: "create" | "edit" = "create") =>
  () => {
    AsoEbiStore.asoEbiDrawerOpenCtx = ctx;
    AsoEbiStore.isAsoEbiDrawerOpen = state === "open";
  };

export const BanksStore = proxy<{ data: Bank[] }>({
  data: [],
});

export const getBankCodeFromBankID = (bankID: string) => {
  for (const bank of BanksStore.data) {
    if (bank._id === bankID) {
      return bank.code;
    }
  }
  return null;
};

export const fetchTicketSettlementAccountData = (weddingID: string) => {
  getSettlementAccount({
    query: {
      weddingID,
    },
    onCompleted(params) {
      AsoEbiStore.settlementAccount = params.data;
    },
    onError(err) {
      console.error(err);
    },
  });
};

// assume this comes from the api
export const updateAsoEbiStatusInStore = (wedding: Wedding) => {
  AsoEbiStore.asoEbiStatus = wedding.asoEbiStatus;
};

// assume this comes from the api
export const updateAsoEbiTransactionCostInStore = (wedding: Wedding) => {
  AsoEbiStore.asoEbiTransactionCostBearer = wedding.asoEbiTransactionCostBearer;
};
